import React from "react"
import {
  Box, Flex, Text, Image, HStack,
} from "@chakra-ui/react"
import SimpleBar from "simplebar-react"
import arrowBack from "assets/images/phone/arrow-back.png"
import whatsappBg from "assets/images/phone/whatsapp-bg.webp"
import logo from "assets/images/diobox-icon.svg"
import StatusBar from "components/Phone/StatusBar"
import TextBubble from "./TextBubble"

type Props = {
  text: React.ReactNode
  mediaUrl?: string
  buttons?: string[]
}

const ProfileCircle = () => (
  <Flex
    w={9}
    h={9}
    borderRadius="full"
    bg="#D0E7FF"
    alignItems="center"
    justifyContent="center"
    flexShrink={0}
    overflow="hidden"
  >
    <Image src={logo} w={9} h={9} mx="auto" />
  </Flex>
)

const WhatsAppScreen = ({
  text, mediaUrl, buttons,
}: Props) => (
  <Flex flexDir="column" h="100%">
    <Box bg="#F4F4F4" pt={6} pb={2} borderBottomWidth={1}>
      <StatusBar />
      <Flex alignItems="center" gap={2} pt={4} px={3}>
        <Image src={arrowBack} h={5} w="auto" />
        <HStack ml={4}>
          <ProfileCircle />
          <Text fontSize="base" fontWeight="semibold" lineHeight="short">
            Diobox
          </Text>
        </HStack>
      </Flex>
    </Box>
    <Box flex={1} overflow="hidden">
      <SimpleBar style={{ height: "100%" }} autoHide>
        <Box
          bgImage={`url(${whatsappBg})`}
          bgSize="cover"
          bgPos="center"
          p={6}
          minH="100%"
        >
          <TextBubble
            text={text}
            channel="whatsapp"
            mediaUrl={mediaUrl}
            buttons={buttons}
          />
        </Box>
      </SimpleBar>
    </Box>
  </Flex>
)

export default WhatsAppScreen
